/** Subject theme keys that reuse another subject's palette and Lottie, mapped
 *  to the key both are registered under. Every key here must also be listed in
 *  that palette's selector in `styles/tokens/subjects.css` — CSS can't read
 *  this map, and `subjectThemeAliases.test.ts` enforces it. */
export const SUBJECT_THEME_ALIASES: Readonly<Record<string, string>> = {
  'marketing-and-developing-a-brand': 'marketing',
  'modern-marketing': 'marketing',
  'marketing-v2': 'marketing',
  'finance-and-data-intelligence': 'financial-and-data-intelligence',
  'financial-and-data-intelligence-v2': 'financial-and-data-intelligence',
  'leadership-principles': 'advanced-leadership',
  'leadership-principles-v2': 'advanced-leadership',
  'product-innovation-v2': 'product-innovation',
  'power-and-influence-v2': 'power-and-influence',
  'ai-for-leaders-v2': 'ai-for-leaders',
  'ai-foundations-v2': 'ai-foundations',
  'high-output-thinking-v2': 'high-output-thinking',
  'high-performance-thinking': 'high-output-thinking',
  'career-growth-and-advancement': 'career-power',
  'career-power-v2': 'career-power',
  'business-strategy-foundations': 'strategy-and-operations',
  'strategy-operations': 'strategy-and-operations',
  'strategy-and-operations-v2': 'strategy-and-operations',
}

export const canonicalSubjectThemeKey = (key: string): string =>
  Object.hasOwn(SUBJECT_THEME_ALIASES, key) ? SUBJECT_THEME_ALIASES[key] : key
